import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShopwareComponent } from './simple-icons-shopware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShopwareComponent ],
    exports:      [ SimpleIconsShopwareComponent ],
    bootstrap:    []
})
export class SimpleIconsShopwareModule {}
